export default __webpack_public_path__ + "static/media/Alex.946c0a2e.JPG";